import { makeActionCreator } from '../../../../utilities'
import { MedicalConsultConstants } from './medicalConsult.constants'

export const setPhysician = makeActionCreator(MedicalConsultConstants.SET_PHYSICIAN, 'physician')
export const setOtherPhysician = makeActionCreator(MedicalConsultConstants.SET_OTHER_PHYSICIAN, 'otherPhysician')
export const setMethod = makeActionCreator(MedicalConsultConstants.SET_METHOD, 'method')
export const setFacility = makeActionCreator(MedicalConsultConstants.SET_FACILITY, 'facility')

export const saveMedicalConsult = makeActionCreator(MedicalConsultConstants.SAVE_MEDICAL_CONSULT, 'data')
export const resetState = makeActionCreator(MedicalConsultConstants.RESET_STATE)
export const setAddToTimeLine = makeActionCreator(MedicalConsultConstants.SET_ADD_TO_TIMELINE, 'addToTimeline')
export const setState = makeActionCreator(MedicalConsultConstants.SET_STATE, 'medicalConsultState')
export const setDateTime = makeActionCreator(MedicalConsultConstants.SET_DATE_TIME, 'time', 'date')
export const setAssessedBy = makeActionCreator(MedicalConsultConstants.SET_ASSESSED_BY, 'assessedBy')
export const onSelectMedicalConsultProcedure = makeActionCreator(MedicalConsultConstants.ON_SELECT_MEDICAL_CONSULT)
export const setUpdateInputRows = makeActionCreator(MedicalConsultConstants.SET_UPDATE_INPUT_ROWS, 'updateInputRows')
export const setSuccessfulAttempt = makeActionCreator(
  MedicalConsultConstants.SET_SUCCESSFUL_ATTEMPT,
  'successfulAttempt'
)
export const setAttempts = makeActionCreator(MedicalConsultConstants.SET_ATTEMPTS, 'attempts')
export const setRolePerforming = makeActionCreator(MedicalConsultConstants.SET_ROLE_PERFORMING, 'rolePerforming')
export const setMedicalConsultDefaults = makeActionCreator(
  MedicalConsultConstants.SET_MEDICAL_CONSULT_DEFAULTS,
  'medicalConsultDefaults'
)
export const setProcedurePerformedByAnotherUnit = makeActionCreator(
  MedicalConsultConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
  'procedurePerformedByAnotherUnit'
)
export const setProcedurePerformedByAnotherUnitPNNV = makeActionCreator(
  MedicalConsultConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
  'procedurePerformedByAnotherUnitPNNV'
)
